<template>
  <div>
    <span class="cover-wrapper">
      <img
        src="../assets/img/about.jpg"
        class="cover"
      >
    </span>
    <div class="container">
      <section class="mb-8 p-4">
        <h1 class="section-title mt-4">Sobre o Psyservice</h1>
        <h2 class="mt-4">
          Quem somos?
        </h2>
        <p>Somos uma equipe que trabalha na busca por serviços especializados em saúde mental com a finalidade de valorizar o seu bem-estar no Brasil.
          Assessoramos VOCÊ profissional para a divulgação ética de seus serviços DIFERENCIADOS com AUTONOMIA! Auxiliando em sua CARREIRA PROFISSIONAL no atual mercado de trabalho.
          Auxiliamos você CLIENTE/PACIENTE encontrar o profissional que irá lhe auxiliar na melhoria de SUA QUALIDADE DE VIDA!
          Venha conhecer e fazer parte desta comunidade cooperativa que valoriza a saúde mental.
        </p>

        <h2 class="mt-4">
          O que fazemos?
        </h2>

        <p>
          Ajudamos você a encontrar o profissional ideal para o seu tratamento de saúde, pois nós VALORIZAMOS A SAÚDE MENTAL.
          Valorizamos o PROFISSIONAL DE EXCELÊNCIA.
          Valorizamos você cliente/paciente que busca QUALIDADE DE VIDA.
          Por valorizarmos a saúde mental através do profissional de excelência que irá lhe proporcionar uma melhor qualidade de vida, convidamos VOCÊ para junto com o PSYSERVICE VIVER BEM, VIVER COM SAÚDE MENTAL. VIVA COM QUALIDADE DE VIDA, GANHE VIDA!

        </p>

        <h2 class="mt-4">
          Nossas histórias
        </h2>

        <p>
          Histórias são construídas por todas as pessoas que compartilham sonhos e buscam viver com saúde para conquistar seus objetivos sonhados. Nós da PSYSERVICE queremos fazer parte da sua história. Somos profissionais preparados e interessados em valorizar a saúde mental no Brasil e no mundo.

        </p>

        <p>
          Queremos auxiliar o acesso para as pessoas a uma melhor qualidade de vida. Todos merecem viver bem! Para atender ao pilar fundamental “VALORIZAÇÃO DA SAÚDE MENTAL” é que a rede PSYSERVICE vem sendo construída com profissionais DIFERENCIADOS!
          PSYSERVICE é uma rede de profissionais que valoriza a saúde mental, valoriza você pois você merece ter o tratamento adequado!
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .cover-wrapper {
    max-height: 30vh;
    overflow: hidden;
    display: block;
  }

  .cover {

    transition: all 1s ease-in-out;
    &:hover {
      transform: scale(1.025)
    }
  }
</style>
